// src/portal/contexts/illustrations/components/BookLibrary/components/FavoritesEmptyState.tsx

'use client';

import { useTranslations } from 'next-intl';
import { Heart } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';

interface FavoritesEmptyStateProps {
  onClearFilter: () => void;
}

export function FavoritesEmptyState({ onClearFilter }: FavoritesEmptyStateProps) {
  const t = useTranslations('illustrations.favorites');

  return (
    <div
      className="flex flex-col items-center justify-center py-12 text-center"
      data-testid="illustration-library-favorites-empty"
    >
      <div className="mb-4 rounded-full bg-muted p-6">
        <Heart className="h-12 w-12 text-muted-foreground" />
      </div>
      <h2 className="mb-2 text-lg font-semibold">{t('noFavoritesYet')}</h2>
      <p className="mb-6 max-w-md text-muted-foreground">{t('noFavoritesHint')}</p>
      <Button
        variant="secondary"
        onClick={onClearFilter}
        data-testid="illustration-favorites-filter-clear"
      >
        {t('clearFavoritesFilter')}
      </Button>
    </div>
  );
}
